import { EField } from "./schema.kyc.types";
import identity from "lodash/identity";
import pickBy from "lodash/pickBy";
export var getInitialValues = function (_a) {
    var user = _a.user;
    var result = {};
    if (user) {
        // Remove "null" values from personalContact
        var personalContact = pickBy(user.personalContact, identity);
        var address = {
            street: personalContact.street,
            number: personalContact.number,
            box: personalContact.box,
            zip: personalContact.zip,
            city: personalContact.city,
            country: personalContact.countryId,
        };
        result[EField.Address] = address;
        result[EField.DateOfBirth] = personalContact.dateOfBirth;
        result[EField.Nationality] = personalContact.nationality;
    }
    return result;
};
